"use strict";

var _classCallCheck = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _inherits = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PoolNotFinalizedError = exports.PreviousEpochNotFinalizedError = exports.ProxyDestinationCannotBeNilError = exports.InitializationError = exports.InvalidProtocolFeePaymentError = exports.InvalidParamValueError = exports.PoolExistenceError = exports.OperatorShareError = exports.OnlyCallableIfNotInCatastrophicFailureError = exports.OnlyCallableIfInCatastrophicFailureError = exports.OnlyCallableByStakingContractError = exports.BlockTimestampTooLowError = exports.MakerPoolAssignmentError = exports.OnlyCallableByPoolOperatorError = exports.InsufficientBalanceError = exports.ExchangeManagerError = exports.OnlyCallableByExchangeError = exports.ExchangeManagerErrorCodes = exports.InitializationErrorCodes = exports.InvalidParamValueErrorCodes = exports.OperatorShareErrorCodes = exports.MakerPoolAssignmentErrorCodes = void 0;

var revert_error_1 = require("../../revert_error"); // tslint:disable:max-classes-per-file


var MakerPoolAssignmentErrorCodes;

(function (MakerPoolAssignmentErrorCodes) {
  MakerPoolAssignmentErrorCodes[MakerPoolAssignmentErrorCodes["MakerAddressAlreadyRegistered"] = 0] = "MakerAddressAlreadyRegistered";
  MakerPoolAssignmentErrorCodes[MakerPoolAssignmentErrorCodes["MakerAddressNotRegistered"] = 1] = "MakerAddressNotRegistered";
  MakerPoolAssignmentErrorCodes[MakerPoolAssignmentErrorCodes["MakerAddressNotPendingAdd"] = 2] = "MakerAddressNotPendingAdd";
  MakerPoolAssignmentErrorCodes[MakerPoolAssignmentErrorCodes["PoolIsFull"] = 3] = "PoolIsFull";
})(MakerPoolAssignmentErrorCodes = exports.MakerPoolAssignmentErrorCodes || (exports.MakerPoolAssignmentErrorCodes = {}));

var OperatorShareErrorCodes;

(function (OperatorShareErrorCodes) {
  OperatorShareErrorCodes[OperatorShareErrorCodes["OperatorShareTooLarge"] = 0] = "OperatorShareTooLarge";
  OperatorShareErrorCodes[OperatorShareErrorCodes["CanOnlyDecreaseOperatorShare"] = 1] = "CanOnlyDecreaseOperatorShare";
})(OperatorShareErrorCodes = exports.OperatorShareErrorCodes || (exports.OperatorShareErrorCodes = {}));

var InvalidParamValueErrorCodes;

(function (InvalidParamValueErrorCodes) {
  InvalidParamValueErrorCodes[InvalidParamValueErrorCodes["InvalidCobbDouglasAlpha"] = 0] = "InvalidCobbDouglasAlpha";
  InvalidParamValueErrorCodes[InvalidParamValueErrorCodes["InvalidRewardDelegatedStakeWeight"] = 1] = "InvalidRewardDelegatedStakeWeight";
  InvalidParamValueErrorCodes[InvalidParamValueErrorCodes["InvalidMaximumMakersInPool"] = 2] = "InvalidMaximumMakersInPool";
  InvalidParamValueErrorCodes[InvalidParamValueErrorCodes["InvalidMinimumPoolStake"] = 3] = "InvalidMinimumPoolStake";
  InvalidParamValueErrorCodes[InvalidParamValueErrorCodes["InvalidEpochDuration"] = 4] = "InvalidEpochDuration";
})(InvalidParamValueErrorCodes = exports.InvalidParamValueErrorCodes || (exports.InvalidParamValueErrorCodes = {}));

var InitializationErrorCodes;

(function (InitializationErrorCodes) {
  InitializationErrorCodes[InitializationErrorCodes["MixinSchedulerAlreadyInitialized"] = 0] = "MixinSchedulerAlreadyInitialized";
  InitializationErrorCodes[InitializationErrorCodes["MixinParamsAlreadyInitialized"] = 1] = "MixinParamsAlreadyInitialized";
})(InitializationErrorCodes = exports.InitializationErrorCodes || (exports.InitializationErrorCodes = {}));

var ExchangeManagerErrorCodes;

(function (ExchangeManagerErrorCodes) {
  ExchangeManagerErrorCodes[ExchangeManagerErrorCodes["ExchangeAlreadyRegistered"] = 0] = "ExchangeAlreadyRegistered";
  ExchangeManagerErrorCodes[ExchangeManagerErrorCodes["ExchangeNotRegistered"] = 1] = "ExchangeNotRegistered";
})(ExchangeManagerErrorCodes = exports.ExchangeManagerErrorCodes || (exports.ExchangeManagerErrorCodes = {}));

var OnlyCallableByExchangeError = /*#__PURE__*/function (_revert_error_1$Rever) {
  _inherits(OnlyCallableByExchangeError, _revert_error_1$Rever);

  var _super = _createSuper(OnlyCallableByExchangeError);

  function OnlyCallableByExchangeError(senderAddress) {
    _classCallCheck(this, OnlyCallableByExchangeError);

    return _super.call(this, 'OnlyCallableByExchangeError', 'OnlyCallableByExchangeError(address senderAddress)', {
      senderAddress: senderAddress
    });
  }

  return OnlyCallableByExchangeError;
}(revert_error_1.RevertError);

exports.OnlyCallableByExchangeError = OnlyCallableByExchangeError;

var ExchangeManagerError = /*#__PURE__*/function (_revert_error_1$Rever2) {
  _inherits(ExchangeManagerError, _revert_error_1$Rever2);

  var _super2 = _createSuper(ExchangeManagerError);

  function ExchangeManagerError(errorCode, senderAddress) {
    _classCallCheck(this, ExchangeManagerError);

    return _super2.call(this, 'ExchangeManagerError', 'ExchangeManagerError(uint8 errorCode, address senderAddress)', {
      errorCode: errorCode,
      senderAddress: senderAddress
    });
  }

  return ExchangeManagerError;
}(revert_error_1.RevertError);

exports.ExchangeManagerError = ExchangeManagerError;

var InsufficientBalanceError = /*#__PURE__*/function (_revert_error_1$Rever3) {
  _inherits(InsufficientBalanceError, _revert_error_1$Rever3);

  var _super3 = _createSuper(InsufficientBalanceError);

  function InsufficientBalanceError(amount, balance) {
    _classCallCheck(this, InsufficientBalanceError);

    return _super3.call(this, 'InsufficientBalanceError', 'InsufficientBalanceError(uint256 amount, uint256 balance)', {
      amount: amount,
      balance: balance
    });
  }

  return InsufficientBalanceError;
}(revert_error_1.RevertError);

exports.InsufficientBalanceError = InsufficientBalanceError;

var OnlyCallableByPoolOperatorError = /*#__PURE__*/function (_revert_error_1$Rever4) {
  _inherits(OnlyCallableByPoolOperatorError, _revert_error_1$Rever4);

  var _super4 = _createSuper(OnlyCallableByPoolOperatorError);

  function OnlyCallableByPoolOperatorError(senderAddress, poolId) {
    _classCallCheck(this, OnlyCallableByPoolOperatorError);

    return _super4.call(this, 'OnlyCallableByPoolOperatorError', 'OnlyCallableByPoolOperatorError(address senderAddress, bytes32 poolId)', {
      senderAddress: senderAddress,
      poolId: poolId
    });
  }

  return OnlyCallableByPoolOperatorError;
}(revert_error_1.RevertError);

exports.OnlyCallableByPoolOperatorError = OnlyCallableByPoolOperatorError;

var MakerPoolAssignmentError = /*#__PURE__*/function (_revert_error_1$Rever5) {
  _inherits(MakerPoolAssignmentError, _revert_error_1$Rever5);

  var _super5 = _createSuper(MakerPoolAssignmentError);

  function MakerPoolAssignmentError(error, makerAddress, poolId) {
    _classCallCheck(this, MakerPoolAssignmentError);

    return _super5.call(this, 'MakerPoolAssignmentError', 'MakerPoolAssignmentError(uint8 error, address makerAddress, bytes32 poolId)', {
      error: error,
      makerAddress: makerAddress,
      poolId: poolId
    });
  }

  return MakerPoolAssignmentError;
}(revert_error_1.RevertError);

exports.MakerPoolAssignmentError = MakerPoolAssignmentError;

var BlockTimestampTooLowError = /*#__PURE__*/function (_revert_error_1$Rever6) {
  _inherits(BlockTimestampTooLowError, _revert_error_1$Rever6);

  var _super6 = _createSuper(BlockTimestampTooLowError);

  function BlockTimestampTooLowError(epochEndTime, currentBlockTimestamp) {
    _classCallCheck(this, BlockTimestampTooLowError);

    return _super6.call(this, 'BlockTimestampTooLowError', 'BlockTimestampTooLowError(uint256 epochEndTime, uint256 currentBlockTimestamp)', {
      epochEndTime: epochEndTime,
      currentBlockTimestamp: currentBlockTimestamp
    });
  }

  return BlockTimestampTooLowError;
}(revert_error_1.RevertError);

exports.BlockTimestampTooLowError = BlockTimestampTooLowError;

var OnlyCallableByStakingContractError = /*#__PURE__*/function (_revert_error_1$Rever7) {
  _inherits(OnlyCallableByStakingContractError, _revert_error_1$Rever7);

  var _super7 = _createSuper(OnlyCallableByStakingContractError);

  function OnlyCallableByStakingContractError(senderAddress) {
    _classCallCheck(this, OnlyCallableByStakingContractError);

    return _super7.call(this, 'OnlyCallableByStakingContractError', 'OnlyCallableByStakingContractError(address senderAddress)', {
      senderAddress: senderAddress
    });
  }

  return OnlyCallableByStakingContractError;
}(revert_error_1.RevertError);

exports.OnlyCallableByStakingContractError = OnlyCallableByStakingContractError;

var OnlyCallableIfInCatastrophicFailureError = /*#__PURE__*/function (_revert_error_1$Rever8) {
  _inherits(OnlyCallableIfInCatastrophicFailureError, _revert_error_1$Rever8);

  var _super8 = _createSuper(OnlyCallableIfInCatastrophicFailureError);

  function OnlyCallableIfInCatastrophicFailureError() {
    _classCallCheck(this, OnlyCallableIfInCatastrophicFailureError);

    return _super8.call(this, 'OnlyCallableIfInCatastrophicFailureError', 'OnlyCallableIfInCatastrophicFailureError()', {});
  }

  return OnlyCallableIfInCatastrophicFailureError;
}(revert_error_1.RevertError);

exports.OnlyCallableIfInCatastrophicFailureError = OnlyCallableIfInCatastrophicFailureError;

var OnlyCallableIfNotInCatastrophicFailureError = /*#__PURE__*/function (_revert_error_1$Rever9) {
  _inherits(OnlyCallableIfNotInCatastrophicFailureError, _revert_error_1$Rever9);

  var _super9 = _createSuper(OnlyCallableIfNotInCatastrophicFailureError);

  function OnlyCallableIfNotInCatastrophicFailureError() {
    _classCallCheck(this, OnlyCallableIfNotInCatastrophicFailureError);

    return _super9.call(this, 'OnlyCallableIfNotInCatastrophicFailureError', 'OnlyCallableIfNotInCatastrophicFailureError()', {});
  }

  return OnlyCallableIfNotInCatastrophicFailureError;
}(revert_error_1.RevertError);

exports.OnlyCallableIfNotInCatastrophicFailureError = OnlyCallableIfNotInCatastrophicFailureError;

var OperatorShareError = /*#__PURE__*/function (_revert_error_1$Rever10) {
  _inherits(OperatorShareError, _revert_error_1$Rever10);

  var _super10 = _createSuper(OperatorShareError);

  function OperatorShareError(error, poolId, operatorShare) {
    _classCallCheck(this, OperatorShareError);

    return _super10.call(this, 'OperatorShareError', 'OperatorShareError(uint8 error, bytes32 poolId, uint32 operatorShare)', {
      error: error,
      poolId: poolId,
      operatorShare: operatorShare
    });
  }

  return OperatorShareError;
}(revert_error_1.RevertError);

exports.OperatorShareError = OperatorShareError;

var PoolExistenceError = /*#__PURE__*/function (_revert_error_1$Rever11) {
  _inherits(PoolExistenceError, _revert_error_1$Rever11);

  var _super11 = _createSuper(PoolExistenceError);

  function PoolExistenceError(poolId, alreadyExists) {
    _classCallCheck(this, PoolExistenceError);

    return _super11.call(this, 'PoolExistenceError', 'PoolExistenceError(bytes32 poolId, bool alreadyExists)', {
      poolId: poolId,
      alreadyExists: alreadyExists
    });
  }

  return PoolExistenceError;
}(revert_error_1.RevertError);

exports.PoolExistenceError = PoolExistenceError;

var InvalidParamValueError = /*#__PURE__*/function (_revert_error_1$Rever12) {
  _inherits(InvalidParamValueError, _revert_error_1$Rever12);

  var _super12 = _createSuper(InvalidParamValueError);

  function InvalidParamValueError(error) {
    _classCallCheck(this, InvalidParamValueError);

    return _super12.call(this, 'InvalidParamValueError', 'InvalidParamValueError(uint8 error)', {
      error: error
    });
  }

  return InvalidParamValueError;
}(revert_error_1.RevertError);

exports.InvalidParamValueError = InvalidParamValueError;

var InvalidProtocolFeePaymentError = /*#__PURE__*/function (_revert_error_1$Rever13) {
  _inherits(InvalidProtocolFeePaymentError, _revert_error_1$Rever13);

  var _super13 = _createSuper(InvalidProtocolFeePaymentError);

  function InvalidProtocolFeePaymentError(expectedProtocolFeePaid, actualProtocolFeePaid) {
    _classCallCheck(this, InvalidProtocolFeePaymentError);

    return _super13.call(this, 'InvalidProtocolFeePaymentError', 'InvalidProtocolFeePaymentError(uint256 expectedProtocolFeePaid, uint256 actualProtocolFeePaid)', {
      expectedProtocolFeePaid: expectedProtocolFeePaid,
      actualProtocolFeePaid: actualProtocolFeePaid
    });
  }

  return InvalidProtocolFeePaymentError;
}(revert_error_1.RevertError);

exports.InvalidProtocolFeePaymentError = InvalidProtocolFeePaymentError;

var InitializationError = /*#__PURE__*/function (_revert_error_1$Rever14) {
  _inherits(InitializationError, _revert_error_1$Rever14);

  var _super14 = _createSuper(InitializationError);

  function InitializationError(error) {
    _classCallCheck(this, InitializationError);

    return _super14.call(this, 'InitializationError', 'InitializationError(uint8 error)', {
      error: error
    });
  }

  return InitializationError;
}(revert_error_1.RevertError);

exports.InitializationError = InitializationError;

var ProxyDestinationCannotBeNilError = /*#__PURE__*/function (_revert_error_1$Rever15) {
  _inherits(ProxyDestinationCannotBeNilError, _revert_error_1$Rever15);

  var _super15 = _createSuper(ProxyDestinationCannotBeNilError);

  function ProxyDestinationCannotBeNilError() {
    _classCallCheck(this, ProxyDestinationCannotBeNilError);

    return _super15.call(this, 'ProxyDestinationCannotBeNilError', 'ProxyDestinationCannotBeNilError()', {});
  }

  return ProxyDestinationCannotBeNilError;
}(revert_error_1.RevertError);

exports.ProxyDestinationCannotBeNilError = ProxyDestinationCannotBeNilError;

var PreviousEpochNotFinalizedError = /*#__PURE__*/function (_revert_error_1$Rever16) {
  _inherits(PreviousEpochNotFinalizedError, _revert_error_1$Rever16);

  var _super16 = _createSuper(PreviousEpochNotFinalizedError);

  function PreviousEpochNotFinalizedError(closingEpoch, unfinalizedPoolsRemaining) {
    _classCallCheck(this, PreviousEpochNotFinalizedError);

    return _super16.call(this, 'PreviousEpochNotFinalizedError', 'PreviousEpochNotFinalizedError(uint256 closingEpoch, uint256 unfinalizedPoolsRemaining)', {
      closingEpoch: closingEpoch,
      unfinalizedPoolsRemaining: unfinalizedPoolsRemaining
    });
  }

  return PreviousEpochNotFinalizedError;
}(revert_error_1.RevertError);

exports.PreviousEpochNotFinalizedError = PreviousEpochNotFinalizedError;

var PoolNotFinalizedError = /*#__PURE__*/function (_revert_error_1$Rever17) {
  _inherits(PoolNotFinalizedError, _revert_error_1$Rever17);

  var _super17 = _createSuper(PoolNotFinalizedError);

  function PoolNotFinalizedError(poolId, epoch) {
    _classCallCheck(this, PoolNotFinalizedError);

    return _super17.call(this, 'PoolNotFinalizedError', 'PoolNotFinalizedError(bytes32 poolId, uint256 epoch)', {
      poolId: poolId,
      epoch: epoch
    });
  }

  return PoolNotFinalizedError;
}(revert_error_1.RevertError);

exports.PoolNotFinalizedError = PoolNotFinalizedError;
var types = [BlockTimestampTooLowError, ExchangeManagerError, InitializationError, InsufficientBalanceError, InvalidProtocolFeePaymentError, InvalidParamValueError, MakerPoolAssignmentError, OnlyCallableByExchangeError, OnlyCallableByPoolOperatorError, OnlyCallableByStakingContractError, OnlyCallableIfInCatastrophicFailureError, OnlyCallableIfNotInCatastrophicFailureError, OperatorShareError, PoolExistenceError, PreviousEpochNotFinalizedError, ProxyDestinationCannotBeNilError, PoolNotFinalizedError]; // Register the types we've defined.

for (var _i = 0, _types = types; _i < _types.length; _i++) {
  var type = _types[_i];
  revert_error_1.RevertError.registerType(type);
}